// extracted by mini-css-extract-plugin
export var cellLeft = "footer-module--cellLeft--OK90c";
export var cellRight = "footer-module--cellRight--4xwuE";
export var footerContainer = "footer-module--footerContainer--qI7VK";
export var jump = "footer-module--jump--lpppn";
export var row = "footer-module--row--J2ZCq";